import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import {Control, UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {Controller } from "react-hook-form";
import {IPharmacyType} from "../../../../queries/pharmacy/pharmacyModel";
import {FormControl, Typography} from "@mui/material";
import {additionalQuestions} from "../../../../constants/signupQuestions";
import Question from "./Question";

interface AdditionalQuestionsProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  control: Control<any>;
}

const AdditionalQuestions: React.FunctionComponent<AdditionalQuestionsProps> = ({
  register,
  errors,
  control,
}) => {

  return (
    <Grid container spacing={2}>
      {additionalQuestions.map((item: any, index: number)=> {
        return (
          <Question
            key={index}
            item={item}
            register={register}
            errors={errors}
            control={control}
          />
        )
      })}
    </Grid>
  )
}

export default AdditionalQuestions;